import React from 'react'
import { Route } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useHasSitesOnProduction } from 'store'
import RouteGuard from 'components/AuthenticatedLayout/RouteGuard/RouteGuard'
import EmptyScreen from 'packages/ui/EmptyScreen'

import IPTV from './IPTV'
import Card from './Card'
import IPTVExport from './Actions/IPTVExport'

const Layout = () => {
  const hasSitesOnProduction = useHasSitesOnProduction()
  const {t} = useTranslation()
  return (
    <RouteGuard requiredRoles={['iptv_channels']}>
      {
        hasSitesOnProduction
          ? <IPTV />
          : <EmptyScreen icon="tv">{t('ui_elements.service_soon')}</EmptyScreen>
      }
    </RouteGuard>
  )
}

export const IPTVRoutes = ({ path = '/iptv' }) => [
  <Route path={path} key="iptv" element={<Layout />}>
    <Route path=":id" element={<Card />} />
    <Route path="export" element={<IPTVExport />} />
  </Route>
]

export default IPTVRoutes
